import VideoPreview from './VideoPreview';

export default VideoPreview;
